const routesPath = {
  LOGIN: '/',
  FORGOT_PASSWORD: '/forgot-password',
  OTP_VERIFICATION: '/otp-verification',
  RESET_PASSWORD: '/reset-password',
  HOME: '/home',
  NOT_FOUND: '/not-found',
  DASHBOARD: '/dashboard',
  ORDERS: '/orders',
  VENDORS: '/vendors',
  CUSTOMERS: '/customers',
  DELIVERY: '/delivery',
  WIDTHDRAWALS: '/withdrawals',
  REFUNDS: '/refunds',
  COMMISSIONS: '/commissions',
  COMMISSIONS_LIST: '/commissions/list',
  APPLICATIONS: '/applications',
  USER_MANAGEMENT: '/user-management',
  COMPLAINTS: '/complaints',
  HELP_CENTER: '/help-center',
  SETTINGS: '/settings',
  VENDOR_LIST: '/vendors/vendor-waiting-list',
  CUSTOMER_LIST: '/customers/customer-waiting-list',
  PAYMENTS: '/payments',
  PAYMENTS_LIST: '/payments/list',
  CUSTOMER_TRANSACTIONS: '/customer-transactions',
  VENDOR_TRANSACTIONS: '/vendor-transactions',
  COMPLETED_DELIVERIES: '/delivery/completed',
  LIVE_DELIVERY_TRACKING: '/delivery/live-tracking',
}

export default routesPath
